{
  "dateFormat": {
    "date": "DD/MM/YYYY",
    "time": "HH:mm",
    "dateTime": "DD/MM/YYYY HH:mm"
  },
  "common": {
    "error": "An error occurred",
    "language": "Language",
    "theme": {
      "auto": "Follow System",
      "light": "Light Mode",
      "dark": "Dark Mode",
      "autoFollowSystem": "Follow System Theme"
    },
    "error_boundary_title": "Something went wrong",
    "error_boundary_subtitle": "The application encountered an unexpected error. Please try reloading the page.",
    "reload": "Reload Page",
    "error_detail": "Error Details:",
    "save": {
      "success": "Saved successfully",
      "failed": "Failed to save"
    },
    "action": {
      "save": "Save",
      "terminate": "Terminate",
      "cancel": "Cancel",
      "ok": "Ok",
      "submit": "Submit",
      "edit": "Edit",
      "add": "Add",
      "search": "Search"
    },
    "form": {
      "association": "Association",
      "alarmTest": "Alarm Test"
    },
    "na": "N/A",
    "loading": "Loading...",
    "backHome": "Back Home",
    "gender": {
      "male": "Male",
      "female": "Female",
      "other": "Other"
    },
    "status": {
      "active": "Active",
      "inactive": "Inactive",
      "pending": "Pending",
      "completed": "Completed"
    },
    "yearsOld": "{{age}} years old",
    "manualUpdate": "Manual Update"
  },
  "reload": {
    "timeout": {
      "title": "Initialization Timeout",
      "content": "The system initialization is taking too long. It is recommended to refresh the page and try again.",
      "okText": "Refresh",
      "cancelText": "Logout"
    }
  },
  "note": {
    "template": {
      "placeholder": "Select a template"
    }
  },
  "exception": {
    "404": {
      "subTitle": "Sorry, the page you visited does not exist."
    },
    "500": {
      "subTitle": "Sorry, something went wrong."
    }
  },
  "auth": {
    "login": {
      "title": "Sign In",
      "subtitle": "Welcome back",
      "submit": "Sign In",
      "success": "Login successful",
      "error": "Login failed",
      "operationFailed": "Operation failed",
      "orSignInWith": "Or sign in with",
      "microsoft": "Microsoft",
      "microsoftLoading": "Processing Microsoft login...",
      "microsoftFailed": "Microsoft login failed: {{error}}",
      "microsoftInvalidState": "Invalid state parameter",
      "microsoftNoCode": "No authorization code received"
    },
    "validation": {
      "account": {
        "required": "Please enter account!",
        "maxLength": "Account length cannot exceed 255 characters"
      },
      "password": {
        "required": "Please enter password!",
        "maxLength": "Password length cannot exceed 128 characters",
        "minLengthDynamic": "Password must be at least {{length}} characters!"
      },
      "email": {
        "required": "Please enter email address!",
        "invalid": "Please enter a valid email address!"
      },
      "field": {
        "required": "Please enter {{field}}!"
      },
      "verificationCode": {
        "required": "Please enter verification code!"
      },
      "confirmPassword": {
        "required": "Please confirm password!"
      },
      "confirmNewPassword": {
        "required": "Please confirm new password!"
      },
      "passwordMismatch": "Passwords do not match!"
    },
    "register": {
      "title": "Sign Up",
      "subtitle": "Create new account",
      "submit": "Sign Up"
    },
    "resetPassword": {
      "title": "Reset Password",
      "subtitle": "Recover your account",
      "submit": "Reset Password",
      "email": "Email",
      "verificationCode": "Verification Code",
      "newPassword": "New Password",
      "confirmPassword": "Confirm New Password",
      "sendCode": "Send Code",
      "resendCode": "Resend",
      "resetButton": "Reset Password",
      "backToSignIn": "Back to Sign In",
      "emailPlaceholder": "Enter email address",
      "verificationCodePlaceholder": "Enter verification code",
      "newPasswordPlaceholder": "Enter new password",
      "confirmPasswordPlaceholder": "Enter new password again",
      "emailRequired": "Please enter email address!",
      "emailInvalid": "Please enter a valid email address!",
      "verificationCodeRequired": "Please enter verification code!",
      "newPasswordRequired": "Please enter new password!",
      "passwordMinLength": "Password must be at least 6 characters!",
      "confirmPasswordRequired": "Please confirm new password!",
      "passwordMismatch": "Passwords do not match!",
      "codeSent": "Verification code sent",
      "sendCodeFailed": "Failed to send verification code",
      "resetSuccess": "Password reset successfully",
      "resetFailed": "Password reset failed",
      "countdown": "Resend in {{seconds}}s"
    },
    "form": {
      "account": {
        "placeholder": "Enter account"
      },
      "password": {
        "placeholder": "Enter password"
      },
      "email": {
        "placeholder": "Enter email address"
      },
      "newPassword": {
        "placeholder": "Enter new password"
      },
      "confirmPassword": {
        "placeholder": "Enter password again"
      },
      "confirmNewPassword": {
        "placeholder": "Enter new password again"
      },
      "verificationCode": {
        "placeholder": "Enter verification code"
      }
    },
    "verification": {
      "getCode": "Get Code",
      "resendIn": "Resend in {{seconds}}s"
    },
    "message": {
      "registerSuccess": "Registration successful",
      "registerFailed": "Registration failed: ",
      "resetSuccess": "Password reset successful",
      "resetFailed": "Password reset failed: "
    },
    "links": {
      "forgotPassword": "Forgot password?",
      "forgotPasswordShort": "Forgot password",
      "signUp": "Sign up now",
      "signIn": "Already have an account? Sign in now",
      "backToSignIn": "Back to Sign In"
    },
    "signIn": {
      "title": "Sign In",
      "subtitle": "Welcome back",
      "username": "Username",
      "password": "Password",
      "rememberMe": "Remember me",
      "forgotPassword": "Forgot password?",
      "signInButton": "Sign In",
      "noAccount": "Don't have an account?",
      "signUpLink": "Sign up now",
      "usernamePlaceholder": "Enter username",
      "passwordPlaceholder": "Enter password",
      "usernameRequired": "Please enter username!",
      "passwordRequired": "Please enter password!"
    },
    "signUp": {
      "title": "Sign Up",
      "subtitle": "Create new account",
      "username": "Username",
      "email": "Email",
      "password": "Password",
      "confirmPassword": "Confirm Password",
      "verificationCode": "Verification Code",
      "sendCode": "Send Code",
      "resendCode": "Resend",
      "signUpButton": "Sign Up",
      "hasAccount": "Already have an account?",
      "signInLink": "Sign in now",
      "usernamePlaceholder": "Enter username",
      "emailPlaceholder": "Enter email address",
      "passwordPlaceholder": "Enter password",
      "confirmPasswordPlaceholder": "Enter password again",
      "verificationCodePlaceholder": "Enter verification code",
      "usernameRequired": "Please enter username!",
      "emailRequired": "Please enter email address!",
      "emailInvalid": "Please enter a valid email address!",
      "passwordRequired": "Please enter password!",
      "passwordMinLength": "Password must be at least 6 characters!",
      "confirmPasswordRequired": "Please confirm password!",
      "passwordMismatch": "Passwords do not match!",
      "verificationCodeRequired": "Please enter verification code!",
      "codeSent": "Verification code sent",
      "sendCodeFailed": "Failed to send verification code",
      "countdown": "Resend in {{seconds}}s"
    }
  },
  "tempNote": {
    "title": {
      "edit": "Edit Temp Note",
      "create": "Create Temp Note"
    },
    "field": {
      "timeRange": "Time Range",
      "reason": "Reason",
      "note": "Note",
      "alarmType": "Alarm Type"
    },
    "placeholder": {
      "startTime": "Start time",
      "endTime": "End time"
    },
    "validation": {
      "selectTimeRange": "Please select time range",
      "selectReason": "Please select a reason",
      "inputNote": "Please input note"
    }
  },
  "notificationCall": {
    "title": {
      "edit": "Edit Notification Call",
      "create": "Create Notification Call"
    },
    "field": {
      "selectPeriod": "Select Period"
    },
    "validation": {
      "selectPeriod": "Please select notification type"
    }
  },
  "arc": {
    "profile": {
      "serviceUser": {
        "ServiceUserIntegration": {
          "viewInPannovation": "View in Pannovation"
        },
        "AssociatedServiceUser": {
          "birthday": "Birthday:",
          "age": "Age: {{age}}",
          "gender": "Gender:",
          "liveStyle": "Live Style:",
          "independentLiving": "Independent Living",
          "groupLiving": "Group Living",
          "phoneNumbers": "Phone numbers",
          "device": "Device",
          "address": "Address:",
          "scheme": "Scheme:",
          "authority": "Authority:",
          "locate": "Locate:",
          "lastUpdate": "Last Update {{time}} ago"
        }
      },
      "schemeAuthority": {
        "AssociatedAuthority": {
          "phoneNumbers": "Phone numbers",
          "administrator": "Administrator",
          "address": "Address:"
        },
        "AssociatedScheme": {
          "phoneNumbers": "Phone numbers",
          "administrator": "Administrator",
          "authority": "Authority",
          "address": "Address:"
        }
      },
      "devices": {
        "Devices": {
          "title": "Devices",
          "columns": {
            "deviceName": "Device Name",
            "type": "Type",
            "guid": "GUID",
            "sn": "SN(Serials number)",
            "address": "Address",
            "status": "Status",
            "action": "Action"
          },
          "type": {
            "connection": "Connection",
            "device": "Device"
          },
          "action": {
            "ignore": "Ignore",
            "restore": "Restore"
          },
          "messages": {
            "failedToUpdate": "Failed to update"
          }
        }
      },
      "subscriptions": {
        "Subscription": {
          "title": "Subscriptions",
          "items": {
            "sub01": {
              "name": "Subscription 01",
              "tier": "Golden",
              "note": "Content some service. Description of the service content, Description of the service content",
              "validity": "Valid until: 2025-12-31"
            },
            "sub02": {
              "name": "Subscription 02",
              "tier": "Silver",
              "note": "Content some service. Description of the service content, Description of the service content",
              "validity": "Valid until: 2026-12-31"
            },
            "sub03": {
              "name": "Subscription 03",
              "tier": "Golden",
              "note": "Description of the service content, Description of the service content"
            }
          }
        }
      },
      "contextPanel": {
        "ServiceUserInfo": {
          "additionalInfo": "Additional Info",
          "email": "Email:",
          "postCode": "Post Code:",
          "contacts": "Contacts"
        },
        "TempNotes": {
          "createdDateTime": "Created Date Time",
          "createdBy": "Created by",
          "completedDateTime": "Completed date time",
          "completedBy": "Completed by",
          "status": "Status",
          "note": "Note"
        },
        "NotificationCalls": {
          "createdDateTime": "Created Date Time",
          "createdBy": "Created by",
          "completedDateTime": "Completed date time",
          "completedBy": "Completed by",
          "status": "Status",
          "note": "Note"
        },
        "Recommended": {
          "smartContext": "Smart Context",
          "note": "Note",
          "recentCalls": "Recent Calls"
        },
        "SchemeInfo": {
          "additionalInfo": "Additional Info",
          "name": "Name:",
          "postCode": "Post Code:",
          "contacts": "Contacts"
        },
        "AuthorityInfo": {
          "additionalInfo": "Additional Info",
          "name": "Name:",
          "postCode": "Post Code:",
          "contacts": "Contacts"
        },
        "CaseManagement": {
          "title": "Case Management",
          "ticketConsole": "Ticket",
          "createTicket": "Create ticket",
          "createTicketSuccess": "Ticket created successfully",
          "ticketId": "Ticket ID",
          "createdDateTime": "Created Date Time",
          "createdBy": "Created by",
          "titleColumn": "Title",
          "description": "Description",
          "category": "Category",
          "priority": "Priority",
          "status": "Status",
          "associateTo": "Associate to",
          "linkedDevices": "Linked devices",
          "ticketAssignedTo": "Ticket assigned to",
          "attachment": "Attachment",
          "uploadButton": "Upload attachment",
          "serviceUserOnlyHint": "Please view or create tickets under a service user profile",
          "uploadTypeError": "Only jpg/png/webp images and PDF files are supported",
          "uploadSizeError": "Each file must be 10MB or smaller",
          "uploadMaxCountError": "Maximum {{max}} files allowed",
          "selectDevices": "Select devices",
          "selectAssociationFirst": "Please select an association first",
          "devicesNotSupportedForRefType": "Devices are not available for this association type",
          "detailedInformation": "Detailed information",
          "addCommentPlaceholder": "Add comment...",
          "createdAt": "Created at",
          "updatedAt": "Updated at",
          "comment": "Comment",
          "statusOptions": {
            "OPEN": "Open",
            "IN_PROGRESS": "In progress",
            "WAITING": "Waiting",
            "CLOSED": "Closed"
          },
          "priorityOptions": {
            "LOW": "Low",
            "NORMAL": "Normal",
            "HIGH": "High"
          },
          "categoryOptions": {
            "DEVICE_FAULT": "Device Fault",
            "CONNECTIVITY": "Connectivity",
            "ALARM_HANDLING": "Alarm handling",
            "ACCOUNT": "Account",
            "OTHER": "Other"
          },
          "validation": {
            "title": "Please input title",
            "description": "Please input description",
            "status": "Please select status",
            "category": "Please select category",
            "priority": "Please select priority",
            "associateTo": "Please select an association"
          }
        },
        "ContextPanel": {
          "tabs": {
            "recommended": "Recommended",
            "information": "Information",
            "sops": "SOPs",
            "notificationCall": "Notification Call",
            "tempNote": "Temp note",
            "audit": "Audit",
            "caseManagement": "Ticket",
            "schemes": "Schemes",
            "serviceUsers": "Service Users"
          }
        },
        "AuthoritySchemeList": {
          "schemeName": "Scheme Name",
          "address": "Address",
          "status": "Status",
          "userNote": "User Note",
          "search": "Search"
        },
        "SchemeServiceUserList": {
          "name": "Name",
          "gender": "Gender",
          "dateOfBirth": "Date of Birth",
          "address": "Address",
          "status": "Status",
          "userNote": "User Note",
          "search": "Search"
        },
        "Sops": {
          "description": "Description of {{chapterName}}"
        }
      }
    },
    "calling": {
      "WaitingControl": {
        "calling": "Calling...",
        "failedToAnswer": "Failed to Answer Call",
        "failedToReject": "Failed to Reject Call"
      },
      "DropdownControl": {
        "failedToMute": "Failed to mute/unmute",
        "unmute": "Unmute",
        "mute": "Mute",
        "record": "Record",
        "recording": "Recording",
        "forward": "Forward",
        "forwarded": "Forwarded",
        "forwardSuccess": "Forward success",
        "failedToForward": "Failed to forward",
        "dial": "Dial",
        "placeholder": {
          "phoneNumber": "Enter phone number",
          "searchColleague": "Search colleague"
        }
      },
      "Status": {
        "iceRecovering": "ICE Recovering...",
        "ended": "Ended",
        "calling": "Calling",
        "forwarding": "Forwarding...",
        "holding": "Holding",
        "recording": "Recording",
        "recordingPaused": "Recording has been paused.",
        "callRejected": "The call was rejected",
        "callNoAnswer": "The call was not answered",
        "callFailed": "The call failed",
        "canceledByUser": "Canceled by user",
        "answerTimeout": "Answer timeout",
        "holdTimeout": "Hold timeout",
        "unholdTimeout": "Unhold timeout",
        "noSessionId": "No callSessionId returned from server",
        "preparingTimeout": "Outbound call timed out, please try again"
      },
      "Control": {
        "failedToHangup": "Failed to Hangup Call",
        "failedToHold": "Failed to Hold/Unhold Call",
        "resume": "Resume",
        "speak": "Speak",
        "busyHere": "Busy Here",
        "rejected": "Rejected",
        "timeout": "Timeout"
      },
      "deviceControl": {
        "VolumeControl": {
          "speaker": "Speaker",
          "messages": {
            "noControls": "No controls",
            "failedToSendCommand": "Failed to send command"
          }
        },
        "NudgeControl": {
          "nudge": "Nudge",
          "messages": {
            "noControls": "No controls",
            "failedToSendCommand": "Failed to send command"
          }
        },
        "DoorControl": {
          "opened": "Opened",
          "locked": "Locked"
        }
      },
      "CallingInfo": {
        "labels": {
          "alarmSessionId": "Alarm Session ID:",
          "association": "Association:"
        },
        "notificationCall": "Notification Call",
        "tags": {
          "inbound": "Inbound",
          "outbound": "Outbound"
        }
      },
      "messages": {
        "callingError": "Calling error, please try again"
      },
      "endCause": {
        "ended": "Call Ended",
        "noAnswer": "No Answer",
        "cancelled": "Cancelled",
        "rejected": "Rejected",
        "failed": "Failed"
      },
      "Recording": {
        "failedToResume": "Failed to resume recording",
        "failedToStop": "Failed to stop recording"
      }
    },
    "statistics": {
      "personal": "Personal",
      "team": "Team",
      "timeRange": {
        "realTime": "real-time",
        "day": "day",
        "month": "month"
      },
      "dataOverview": "Data Overview",
      "workPerformance": "Work performance",
      "todayTotalDuration": "Today's total duration",
      "atWork": "At work",
      "onBreak": "On break",
      "serviceLevel": "Service Level",
      "callsVolume": "Calls Volume",
      "avgHandleTime": "Average call handle time",
      "avgResponseTime": "Average call response time",
      "totalCalls": "Total Calls",
      "inbound": "Inbound",
      "outbound": "Outbound",
      "inboundCallStatistics": "Inbound Call Statistics",
      "handledCount": "Handled: {{count}}",
      "rejectedCount": "Rejected: {{count}}",
      "overtimeCount": "Overtime: {{count}}",
      "teamStatus": {
        "title": "Operator Status - Total: {{total}}",
        "available": "Available",
        "incall": "Incall",
        "acw": "ACW",
        "admin": "Admin",
        "offline": "Offline"
      }
    },
    "admin": {
      "CallLogEdit": {
        "failedToSave": "Failed to save, please try again later.",
        "successfullySaved": "Successfully saved.",
        "save": "Save"
      }
    },
    "widgets": {
      "arcHeader": {
        "menu": {
          "callLogs": "Call logs",
          "statistics": "Statistics",
          "callOut": "Call out",
          "dialCard": "Dial Card"
        },
        "OperatorInfo": {
          "status": {
            "offline": "Offline",
            "available": "Available",
            "admin": "Admin"
          },
          "online": "Online:"
        }
      },
      "AdminStatisticsNav": {
        "callLogs": "Call Logs",
        "statistics": "Statistics"
      },
      "TempNoteEdit": {
        "title": {
          "edit": "Edit Temp Note",
          "create": "Create Temp Note"
        },
        "field": {
          "timeRange": "Time Range",
          "reason": "Reason",
          "note": "Note",
          "alarmType": "Alarm Type",
          "association": "Association",
          "associateTo": "Associate to"
        },
        "placeholder": {
          "startTime": "Start time",
          "endTime": "End time",
          "note": "Please input note"
        },
        "validation": {
          "selectTimeRange": "Please select time range",
          "selectReason": "Please select a reason",
          "inputNote": "Please input note"
        }
      },
      "NotificationCallEdit": {
        "title": {
          "edit": "Edit Notification Call",
          "create": "Create Notification Call"
        },
        "field": {
          "selectPeriod": "Select Period",
          "reason": "Reason",
          "note": "Note",
          "association": "Association",
          "timeRange": "Time Range",
          "associateTo": "Associate to"
        },
        "validation": {
          "selectPeriod": "Please select notification type",
          "selectReason": "Please select a reason",
          "inputNote": "Please input note",
          "selectTimeRange": "Please select time range"
        }
      },
      "SearchModal": {
        "title": "Search ARC",
        "placeholder": {
          "search": "Search",
          "searchEverything": "Search Everything"
        },
        "noResults": "No results found.",
        "searchFailed": "Search failed. Please try again.",
        "columns": {
          "name": "Name",
          "info": "Info",
          "address": "Address"
        },
        "phoneNumbers": "Phone Numbers",
        "scopes": {
          "all": "All",
          "serviceUser": "Service User",
          "scheme": "Scheme",
          "authority": "Authority",
          "contact": "Contact"
        },
        "types": {
          "service_user": "Service User",
          "service_scheme": "Scheme",
          "authority": "Authority",
          "contact": "Contact"
        }
      },
      "RejectCallReasonForm": {
        "title": "Reject Reason",
        "field": {
          "reason": "Reason",
          "description": "Description"
        },
        "validation": {
          "selectReason": "Please select a reason"
        },
        "messages": {
          "failedToSubmit": "Failed to Submit"
        }
      },
      "arcBackgroundTask": {
        "InitUnCompletedCallings": {
          "title": "You have a incomplete transaction",
          "message": "Please complete the remaining steps."
        }
      },
      "statusIndicator": {
        "sip": {
          "new": "NEW",
          "checking": "CHECKING",
          "connected": "CONNECTED",
          "disconnected": "DISCONNECTED",
          "failed": "FAILED",
          "closed": "CLOSED",
          "completed": "COMPLETED"
        },
        "register": {
          "unregistered": "UNREGISTERED",
          "registered": "REGISTERED",
          "registerFailed": "REGISTER_FAILED",
          "registrationExpiring": "REGISTRATION_EXPIRING"
        }
      },
      "operationPanel": {
        "markAsDone": "Mark as Done",
        "tempNote": "Temp Note",
        "notificationCall": "Notification Call",
        "messages": {
          "saveSuccess": "Call logs saved successfully",
          "saveFailed": "Failed to save call logs",
          "statusUpdateFailed": "Failed to update operator status"
        }
      },
      "associationSelect": {
        "title": "Select Association",
        "associateTo": "Call-associated to",
        "search": "Search",
        "serviceUser": "Service User",
        "scheme": "Scheme",
        "authority": "Authority",
        "columns": {
          "name": "Name",
          "birthday": "Birthday",
          "age": "Age",
          "gender": "Gender",
          "salesType": "Sales Type",
          "status": "Status",
          "address": "Address"
        }
      },
      "offline": {
        "OfflinePage": {
          "currentlyOffline": "Currently offline",
          "available": "Available",
          "admin": "Admin",
          "logout": "Logout",
          "messages": {
            "failedToUpdate": "Failed to Update Status"
          }
        }
      },
      "available": {
        "AvailablePage": {
          "operatorsAhead": "Available Operators ahead:"
        }
      },
      "viser": {
        "notification": {
          "supervisor": "Notification Tell the supervisor something worth noting"
        },
        "waitingCalls": {
          "messages": {
            "accepted": "You have successfully accepted the call.",
            "acceptedHandleElsewhere": "You have successfully accepted the call. please handle it in the Calling page."
          }
        }
      },
      "components": {
        "listItems": {
          "SubscriptionItem": {
            "validUntil": "Valid until: {{date}}"
          }
        }
      }
    },
    "callLogs": {
      "DateRangeInput": {
        "last7Days": "Last 7 Days",
        "last30Days": "Last 30 Days",
        "last90Days": "Last 90 Days",
        "last6Months": "Last 6 Months",
        "startDate": "Start date",
        "endDate": "End date"
      },
      "CallLogsSearch": {
        "dateTimeRange": "Date/time Range",
        "callerRecipient": "Caller/Recipient",
        "associateTo": "Associate to",
        "callType": "Call type",
        "searchType": "Search type",
        "operator": "Operator",
        "search": "Search",
        "apply": "Apply",
        "reset": "Reset",
        "options": {
          "reason": "Reason",
          "outcome": "Outcome",
          "note": "Note",
          "serviceUser": "Service User",
          "contact": "Contact",
          "connection": "Connection",
          "other": "Other",
          "scheme": "Scheme",
          "authority": "Authority",
          "inbound": "Inbound",
          "outbound": "Outbound",
          "me": "Me",
          "others": "Others"
        }
      },
      "callLogsColumns": {
        "dateTime": "Date and Time",
        "callerRecipient": "Caller/Recipient",
        "associateTo": "Associate to",
        "callType": "Call type",
        "reason": "Reason",
        "outcome": "Outcome",
        "operator": "Operator",
        "missed": "Missed",
        "rejected": "Rejected",
        "waiting": "Waiting",
        "pending": "Pending",
        "inProgress": "In Progress",
        "ended": "Ended",
        "completed": "Completed"
      }
    }
  },
  "operatorStatus": {
    "update": {
      "failed": "Failed to Update Status"
    },
    "offlineReason": "Offline Reason",
    "field": {
      "reason": "Reason",
      "description": "Description"
    },
    "validation": {
      "selectReason": "Please select a reason"
    }
  },
  "audit": {
    "dateTime": "Date Time",
    "operationType": "Operation Type",
    "field": "Field",
    "modifier": "Modifier",
    "modifiedFields": "Modified Fields",
    "oldValue": "Old Value",
    "newValue": "New Value",
    "search": "Search"
  }
}
